<div class="sg-social">
    <div class="container">
        <div class="row">
            <div class="col-12 col-lg-6 sg-social-links">
                <div class="row mx-2 mx-md-5 pt-1">
                    <div class="text-center mt-4 text-center" *ngFor="let item of icons; let last = last;" [ngClass]="item.className">
                        <a href="" [href]="item.iconLink" target="_blank" [class.mr-5]="!last" (click)="sendClickEvent(item)">
                            <mlp-ng-icon [name]="item.iconName" size="large"></mlp-ng-icon>
                        </a>
                    </div>
                </div>
            </div>
            <div class="col-md-1 px-0 d-none d-lg-flex flex-row sg-social-links">
                <div class="w-100"></div>
                <div class="triangle-top-left"></div>
            </div>
            <div class="col-12 col-lg-5 sg-social-newsletter">
                <form ngNoForm [action]="action" method="POST" target="_blank">

                <div class="text-center text-sm-left">
                    <div class="sg-heading__h4 my-2">THE BEST EMAILS IN THE GAME</div>
                </div>
                <div class="row">
                    <div class="col-12 col-sm-8 col-lg-7 col-xl-8 mb-2 pb-1">
                        <mlp-ng-input placeholder="Email" inputName="EMAIL" inputId="newsletter"></mlp-ng-input>
                    </div>
                    <div class="col-12 col-sm-4 col-lg-5 col-xl-4 mb-2 pb-1 text-nowrap">
                        <div class="d-none d-sm-flex">
                            <mlp-ng-button-atom label="Sign up" btnType="submit" btnStyle="secondary"></mlp-ng-button-atom>
                        </div>
                        <div class="d-sm-none">
                            <mlp-ng-button-atom label="Sign up" btnType="submit" fullWidth="1" btnStyle="secondary"></mlp-ng-button-atom>
                        </div>
                    </div>
                </div>
                </form>
            </div>
        </div>
    </div>
</div>
